import { BaseView } from 'Common/BaseView';

export class UnauthorizedBaseView extends BaseView {

    constructor() {
        super();
    }

    public GoBack() {
        window.history.back();
    }
}